// 获取cookie、
function getCookie(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if ((arr = document.cookie.match(reg))) return arr[2];
  else return null;
}

// 设置cookie,增加到vue实例方便全局调用
function setCookie(name, value, expireHorus) {
  var exdate = new Date();
  exdate.setTime(exdate.getTime() + (expireHorus+8)*60*60*1000);
  document.cookie = name + '=' + escape(value) + (expireHorus == null ? '' : ';expires=' + exdate.toUTCString());
}

// 删除cookie
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString();
}

// 检查cookie
function checkCookie(name) {
  var value = getCookie(name);
  if (value == "" || value == null) {
    return false;
  } else {
    return true;
  }
}

export default {
  get(name) {
    return getCookie(name);
  },
  set(name, value, expireHorus) {
    return setCookie(name, value, expireHorus);
  },
  del(name) {
    return delCookie(name);
  },
  check(name) {
    return checkCookie(name);
  }
}
